// src/time/index.ts
var SECOND_MS = 1e3;
var MINUTE_MS = 60 * SECOND_MS;
var HOUR_MS = 60 * MINUTE_MS;
var DAY_MS = 24 * HOUR_MS;
var WEEK_MS = 7 * DAY_MS;
function days(count) {
  return count * DAY_MS;
}
function toMillis(value, unit) {
  return unit === "seconds" ? value * 1e3 : value;
}
function toDate(value, unit = "seconds") {
  return new Date(toMillis(value, unit));
}
function formatTimestamp(value, opts = {}) {
  const { unit = "seconds", locale, dateStyle = "medium", timeStyle = "short", timeZone } = opts;
  return new Intl.DateTimeFormat(locale, { dateStyle, timeStyle, timeZone }).format(toDate(value, unit));
}
function formatDate(value, opts = {}) {
  const { unit = "seconds", locale, dateStyle = "medium", timeZone } = opts;
  return new Intl.DateTimeFormat(locale, { dateStyle, timeZone }).format(toDate(value, unit));
}
var RELATIVE_DIVISIONS = [
  { amount: 60, unit: "second" },
  { amount: 60, unit: "minute" },
  { amount: 24, unit: "hour" },
  { amount: 7, unit: "day" },
  { amount: 4.34524, unit: "week" },
  { amount: 12, unit: "month" },
  { amount: Number.POSITIVE_INFINITY, unit: "year" }
];
function formatRelativeTime(value, opts = {}) {
  const { unit = "seconds", locale, nowMs = Date.now(), numeric = "auto" } = opts;
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric });
  let delta = (toMillis(value, unit) - nowMs) / 1e3;
  for (const division of RELATIVE_DIVISIONS) {
    if (Math.abs(delta) < division.amount) {
      return rtf.format(Math.round(delta), division.unit);
    }
    delta /= division.amount;
  }
  return rtf.format(Math.round(delta), "year");
}
var LAST_REAL_TIMESTAMP_S = 253402300799;
function timestampFace(raw, opts = {}) {
  const text = typeof raw === "number" && Number.isFinite(raw) ? String(Math.trunc(raw)) : typeof raw === "string" ? raw.trim() : "";
  if (!/^\d+$/.test(text) || /^0+$/.test(text)) return null;
  if (text.length > 15 || Number(text) > LAST_REAL_TIMESTAMP_S) {
    return { text: "Never", title: `${text} \u2014 a "no deadline" sentinel no clock reaches`, never: true };
  }
  const seconds = Number(text);
  return {
    text: formatTimestamp(seconds, { locale: opts.locale, timeZone: opts.timeZone }),
    title: `${formatRelativeTime(seconds, { nowMs: opts.nowMs, locale: opts.locale })} \xB7 ${text}`
  };
}
function toDateTimeLocal(value, unit = "seconds") {
  if (value == null || !Number.isFinite(value) || value <= 0) return "";
  const d = toDate(value, unit);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
function fromDateTimeLocal(value) {
  const raw = (value ?? "").trim();
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  if (Number.isNaN(ms)) return null;
  return Math.floor(ms / 1e3);
}
function formatDuration(ms) {
  const abs = Math.abs(ms);
  if (abs < 1e3) return `${Math.round(ms)}ms`;
  if (abs < 6e4) return `${(ms / 1e3).toFixed(abs < 1e4 ? 1 : 0)}s`;
  const sign = ms < 0 ? "-" : "";
  const totalSeconds = Math.round(abs / 1e3);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor(totalSeconds % 3600 / 60);
  const s = totalSeconds % 60;
  if (h > 0) return m > 0 ? `${sign}${h}h ${m}m` : `${sign}${h}h`;
  if (m > 0) return s > 0 ? `${sign}${m}m ${s}s` : `${sign}${m}m`;
  return `${sign}${s}s`;
}

export { DAY_MS, HOUR_MS, LAST_REAL_TIMESTAMP_S, MINUTE_MS, SECOND_MS, WEEK_MS, days, formatDate, formatDuration, formatRelativeTime, formatTimestamp, fromDateTimeLocal, timestampFace, toDate, toDateTimeLocal };
//# sourceMappingURL=chunk-VEM22REL.js.map
//# sourceMappingURL=chunk-VEM22REL.js.map